import auth from "@/store/auth.module"

export function redirectAuth() {

  let devicePlatform = returnPlatformDevice()

  if(devicePlatform == 'iPhone') {
    auth.actions.loadLogOut().then(() => {
      window.location.href = "#logout"
    })
  }

  if(devicePlatform != 'iPhone' && window.location.pathname != "/"){
    auth.actions.loadLogOut().then(() => {
      window.androidFunctions.exitFromAccount("0");
    })
  }
   
}

function returnPlatformDevice() {
  
  let userDeviceArray = [
    {device: 'Android', platform: /Android/},
    {device: 'iPhone', platform: /iPhone/},
  ];

  var platform = navigator.userAgent;

  for (var i in userDeviceArray) {
    if (userDeviceArray[i].platform.test(platform)) return userDeviceArray[i].device;
  }

}